import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Pagination } from 'react-bootstrap';
import './style.css';
const VnPagination = ({ totalPages, currentPage, onPageChange }) => {
    const maxVisiblePages = 5;
    const getPageNumbersWithDots = () => {
        if (totalPages === undefined || totalPages === 1)
            return [];
        else {
            if (totalPages <= maxVisiblePages)
                return Array.from({ length: totalPages }, (_, index) => index + 1);
            const halfMaxVisiblePages = Math.floor(maxVisiblePages / 2);
            let startPage = currentPage - halfMaxVisiblePages;
            let endPage = currentPage + halfMaxVisiblePages;
            if (startPage <= 1) {
                startPage = 1;
                endPage = maxVisiblePages;
            }
            if (endPage >= totalPages) {
                endPage = totalPages;
                startPage = totalPages - maxVisiblePages + 1;
            }
            const pageNumbers = [];
            if (startPage > 1)
                pageNumbers.push(1);
            if (startPage > 2)
                pageNumbers.push(-1); // Ellipsis for hidden pages
            for (let i = startPage; i <= endPage; i++) {
                pageNumbers.push(i);
            }
            if (endPage < totalPages - 1)
                pageNumbers.push(-1); // Ellipsis for hidden pages
            if (endPage < totalPages)
                pageNumbers.push(totalPages);
            return pageNumbers;
        }
    };
    return (_jsx(React.Fragment, { children: totalPages > 1 ? (_jsxs(Pagination, { size: 'sm', className: 'd-flex justify-content-center', children: [_jsx(Pagination.First, { onClick: () => onPageChange(1), disabled: currentPage === 1 }), _jsx(Pagination.Prev, { onClick: () => onPageChange(currentPage - 1), disabled: currentPage === 1 }), getPageNumbersWithDots().map((pageNumber, index) => pageNumber === -1 ? (_jsx(Pagination.Ellipsis, {}, index)) : (_jsx(Pagination.Item, { active: pageNumber === currentPage, onClick: () => onPageChange(pageNumber), children: pageNumber }, index))), _jsx(Pagination.Next, { disabled: currentPage === totalPages, onClick: () => onPageChange(currentPage + 1) }), _jsx(Pagination.Last, { disabled: currentPage === totalPages, onClick: () => onPageChange(totalPages) })] })) : (_jsx(_Fragment, {})) }));
};
export default VnPagination;
